import { bookingArrival, bookingDeparture, fmtDateAndTime } from "./adminHelpers";

/* Semantic UI's orange — the room's "Departs" label in BookingDetailModal
   wears it, so a moved date reads the same in the table as in the modal. */
const CHANGED_COLOR = "#f2711c";

function StayDateCell({ value }) {
  const text = fmtDateAndTime(value.date, value.time);
  if (!value.changed) return text;
  return (
    <span style={{ color: CHANGED_COLOR }} title={`Originally ${value.original}`}>
      {text}
    </span>
  );
}

/* The booking tables' Departure cell: when the stay really ends (see
   bookingDeparture), in orange with the booked departure on hover once that
   has moved. */
export default function DepartureCell({ booking }) {
  return <StayDateCell value={bookingDeparture(booking)} />;
}

/* The Arrival cell, the same way round: when the stay really starts (see
   bookingArrival) — a room confirmed or moved onto its own window starts
   then, not on the booked date. */
export function ArrivalCell({ booking }) {
  return <StayDateCell value={bookingArrival(booking)} />;
}
